var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { Button } from '../../Button';
var DeleteButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 3;\n  position: absolute;\n  margin-top: 64px;\n  width: inherit;\n  align-self: end;\n  margin-right: 8px;\n"], ["\n  z-index: 3;\n  position: absolute;\n  margin-top: 64px;\n  width: inherit;\n  align-self: end;\n  margin-right: 8px;\n"])));
export var ImagePreviewTrashButton = function (props) {
    return (React.createElement(DeleteButton, __assign({ iconSrc: "Bin", size: "small", "data-testid": "trash-can-delete-button", "aria-label": "Delete trash can icon" }, props)));
};
var templateObject_1;
